import { KEYWORD_TAB_TITLE, WEBSITE_TAB_TITLE } from "app/pages/activation/components/HomeSearch/texts";

import { SearchTabs } from "./types";

export const SEARCH_TAB_DICTIONARY = {
    [SearchTabs.Website]: { id: SearchTabs.Website, title: WEBSITE_TAB_TITLE },
    [SearchTabs.Keyword]: { id: SearchTabs.Keyword, title: KEYWORD_TAB_TITLE },
};

export const TAB_LIST = Object.keys(SEARCH_TAB_DICTIONARY);

export const DEFAULT_KEYWORDS = [
    "credit cards",
    "mortgage rates",
    "CRM software",
    "insurance quotes",
    "flight deals",
    "men's sneakers",
    "vpn streaming",
    "skincare brands",
    "student laptops",
    "weight loss",
];

export const DEFAULT_WEBSITES = ["google.com", "youtube.com", "facebook.com", "amazon.com", "wikipedia.org"];

export const WEBSITES_RESPONSE_LENGTH = 25;
export const FALLBACK_COUNTRY = "999";
export const FALLBACK_DURATION = "7d";
